<style>

/* *{
  border: 1px red solid;
} */


.edit, .edit-container{
  display: grid;
  grid-template-columns: auto 32px;
  grid-template-rows: 50px;
  align-items: center;
  border: 1px rgba(255,255,255,0.2) solid;
  background-color: rgba(255,255,255,0.07);
  border-radius: 10px;
  margin: 10px 3px;
}
.edit-container{
  grid-template-rows: 50px auto auto;
}
.edit-info{
  grid-column: 1;
  grid-row: 1;
}
.edit-icon{
  grid-column: 2;
  grid-row: 1;
}
.edit-item{
  margin-top: 10px;
  grid-row: 2;
  grid-column-start: 1;
  grid-column-end: 3;
}
.edit-see-more{
  text-align: center;
  margin-bottom: 10px;
  grid-row: 3;
  grid-column-start: 1;
  grid-column-end: 3;
}

img{
  object-fit: cover;
  width: calc(100% - 6px);
  margin: 3px;
  border-radius: 10px;
}

.user-info{
  margin: 10px;
}
.name{
  font-size: 21px;
  font-weight: bold;
}

.about-me{
  /* font-family: Sansation; */
  /* font-size: 24px; */
  /* font-style: italic; */
  margin: 10px 10px 5px 10px;
}
.bio{
  margin: 0 10px 10px 10px;
}
.chars-left, .small-print{
  font-size: 16px;
  margin: 0 10px 0 10px;
  color: white;
}

/* 
.photos{
  display: flex;
  justify-content: center;
  margin-bottom: 40px;
}

.a-photo{
  width: 100px;
  height: 100px;
  background-image: url('/i/alison-james-pic01.jpg');
  background-color: gray;
  background-repeat: no-repeat;
  background-origin: border-box;
  background-clip: border-box;
  background-size: cover;
  margin: 5px;
}
*/

.my-interests{
  margin: 10px;
}

.questions{
  margin: 10px;
}

.edit-extra{
  margin: 0 10px 10px 10px;
}

.upcoming{
  font-family: Sansation;
  font-size: 14px;
  font-style: italic;
  width: 300px;
  margin: 20px auto 10px auto;
}

.card{
  position: relative;
  color: white;
}

.event-name{
  font-size: 21px;
}

.starts-in {
  position: absolute;
  top: 10px;
  left: 10px;
  padding: 5px;
  background-color: rgba(0,0,0,0.8);
  border-radius: 5px;
  /* box-shadow: 3px 3px 5px #000; */
}
.info{
  position: absolute;
  bottom: 16px;
  left: 10px;
  right: 10px;
  padding: 5px;
  border-radius: 5px;
  /* border: 1px red solid; */
  /* margin-top: -40px; */
  background-color: rgba(0,0,0,0.8);
  /* box-shadow: 3px 3px 5px #000; */
}
.stars{
  position: absolute;
  top: 10px;
  right: 10px;
  padding: 5px;
  background-color: rgba(0,0,0,0.8);
  border-radius: 5px;
}
.disabled{
  color: gray;
}

.sub-item{
  height: 100px;
  text-align: center;
  background-position: center center;
  background-repeat: no-repeat;
  background-origin: border-box;
  background-clip: border-box;
  background-size: cover;
  border-radius: 10px;
  border: 1px #333 solid;
  margin: 10px 10px;
  box-shadow: 0 0 3px #333;
}
.sub-item-text{
  margin-top: 35px;
  font-size: 26px;
  font-weight: bold;
  text-shadow: 1px 1px 3px rgba(0,0,0,1);
}

.question{
  margin: 28px 28px 10px 28px;
}
.question-answer{
  margin: 0 0 0 9px;
}
.question-slider{
  margin: 10px 16px;
}

.me, .them{
  display: inline-block;
  height: 15px;
  width: 15px;
  border-radius: 20px;
  background-color: #00d1ff;
}
.them{
  background-color: #fff500;
}

</style>

<Auth bind:this="{auth}"></Auth>
<Profile bind:this="{profile}" bind:me="{me}"></Profile>

<Dialog show="{edit != '' ? true : false }" title="" height="{editHeight}" buttons="{ buttons }" on:close="{ cancel }" on:save="{ save }">
  
  <InviteCodes bind:this="{EditMe['Invite Codes'].component}" bind:me="{me}" show="{ edit == 'Invite Codes' ? true : false }" on:genInviteCode="{ () => editHeight = 600 }" on:codeCopied="{ () => editHeight = 350 }"></InviteCodes>
  
  <Photos bind:this="{EditMe['Photos'].component}" bind:me="{me}" show="{ edit == 'Photos' ? true : false }" bind:photosAdd="{photosAdd}"></Photos>
  
  <Name bind:this="{EditMe['Name'].component}" bind:me="{me}" show="{ edit == 'Name' ? true : false }"></Name>

  <AboutMe bind:this="{EditMe['About Me'].component}" bind:me="{me}" show="{ edit == 'About Me' ? true : false }"></AboutMe>

  <Email bind:this="{EditMe['Email'].component}" bind:me="{me}" show="{ edit == 'Email' ? true : false }" on:showVerify="{ () => load('Email Verify') }"></Email>

  <EmailVerify bind:this="{EditMe['Email Verify'].component}" bind:me="{me}" show="{ edit == 'Email Verify' ? true : false }"></EmailVerify>
  
  <!-- <Phone bind:this="{EditMe['Phone'].component}" bind:me="{me}" show="{ edit == 'Phone' ? true : false }" on:showVerify="{ () => load('Phone Verify') }"></Phone> -->
  <Phone bind:this="{EditMe['Phone'].component}" bind:me="{me}" show="{ edit == 'Phone' ? true : false }"></Phone>

  <!-- <PhoneVerify bind:this="{EditMe['Phone Verify'].component}" bind:me="{me}" show="{ edit == 'Phone Verify' ? true : false }"></PhoneVerify> -->

  <Password bind:this="{EditMe['Password'].component}" bind:me="{me}" show="{ edit == 'Password' ? true : false }"></Password>
  
  <Interests bind:this="{EditMe['Interests'].component}" bind:me="{me}" show="{ edit == 'Interests' ? true : false }"></Interests>

  <QuestionsC bind:this="{EditMe['Questions'].component}" bind:me="{me}" show="{ edit == 'Questions' ? true : false }"></QuestionsC>

  <Gender bind:this="{EditMe['Gender'].component}" bind:me="{me}" show="{ edit == 'Gender' ? true : false }" on:showAll="{ () => {editHeight = '100%'} }"></Gender>
  
  <GenderLookingFor bind:this="{EditMe['Gender Looking For'].component}" bind:me="{me}" show="{ edit == 'Gender Looking For' ? true : false }" on:showAll="{ () => {editHeight = '100%'} }"></GenderLookingFor>

  <AgePreference bind:this="{EditMe['Age Preference'].component}" bind:me="{me}" show="{ edit == 'Age Preference' ? true : false }"></AgePreference>

  <Location bind:this="{EditMe['Location'].component}" bind:me="{me}" show="{ edit == 'Location' ? true : false }" on:expand="{ () => editHeight = 670 }" on:shorten="{ () => editHeight = 420 }"></Location>

  <SocialLinks bind:this="{EditMe['Social Links'].component}" bind:me="{me}" show="{ edit == 'Social Links' ? true : false }"></SocialLinks>
  
  {#if (edit in EditMe) == false }
    Not implemented
  {/if}
  
</Dialog>

<Header
buttons="{ [ {icon: 'icon-date_range', text: 'All Upcoming Events', callback: 'upcoming', disabled: false, }, ] }"
leftIcon="{ {icon: 'icon-heart3', text: 'Friends', callback: 'friends', disabled: false, } }"
on:friends="{ () => push('/friends-incoming') }"
on:upcoming="{ () => push('/events-upcoming') }">My Profile</Header>
<div class="has-header"></div>


<!-- if loaded "me" then we'll show the settings -->
{#if me.uid != ""}

<div class="edit" on:click="{ () => load('Invite Codes') }">
  <div class="edit-info">
    <div class="user-info">Invite Codes</div>
  </div>
  <div class="edit-icon">
    <i class="icon-pencil3"></i>
  </div>
  <div class="edit-item">
    <div class="edit-extra">
      Invite your friends to join!
    </div>
  </div>
</div>


<div class="edit-container" on:click="{ () => load('Photos') }">
  <div class="edit-info">
    <div class="user-info">
      Photos
    </div>
  </div>
  <div class="edit-icon">
    <i class="icon-pencil3"></i>
  </div>
  <div class="edit-item">
    <img src="https://routes.hot0.workers.dev/fi/{localStorage.getItem('cookie')}/{localStorage.getItem('csrf')}/{me.uid}/{me.photoIds[0]}" alt="" class="img">
  </div>
</div>


<div class="edit" on:click="{ () => load('Name') }">
  <div class="edit-info">
    <div class="user-info">
      <div class="name">{me.name}</div>
    </div>
  </div>
  <div class="edit-icon">
    <i class="icon-pencil3"></i>
  </div>
</div>
  
<div class="spacer"></div>


<div class="edit-container" on:click="{ () => load('About Me') }">
  <div class="edit-info">
    <div class="about-me">About Me</div>
  </div>
  <div class="edit-icon">
    <i class="icon-pencil3"></i>
  </div>
  <div class="edit-item">
    <div class="bio" on:click="{ () => load('About Me') }">{me.bio}</div>
  </div>
</div>


<div class="edit" on:click="{ () => load('Email') }">
  <div class="edit-info">
    <div class="user-info">Email</div>
  </div>
  <div class="edit-icon">
    <i class="icon-pencil3"></i>
  </div>
  <div class="edit-item">
    <div class="bio" on:click="{ () => load('About Me') }">{me.email}</div>
  </div>
</div>


<div class="edit" on:click="{ () => load('Phone') }">
  <div class="edit-info">
    <div class="user-info">Phone</div>
  </div>
  <div class="edit-icon">
    <i class="icon-pencil3"></i>
  </div>
  <div class="edit-item">
    <div class="bio" on:click="{ () => load('About Me') }">{UnitedStates.phone(me.phone)}</div>
  </div>
</div>

  
<div class="edit" on:click="{ () => load('Password') }">
  <div class="edit-info">
    <div class="user-info">Change Password</div>
  </div>
  <div class="edit-icon">
    <i class="icon-pencil3"></i>
  </div>
</div>


<!-- 
<div class="photos">
  <div class="a-photo"></div>
  <div class="a-photo"></div>
  <div class="a-photo"></div>
</div>
-->


<div class="edit" on:click="{ () => load('Interests') }">
  <div class="edit-info">
    <div class="user-info">My Interests</div>
  </div>
  <div class="edit-icon">
    <i class="icon-pencil3"></i>
  </div>
  <div class="edit-item">
    {#each myInterests as item}
      <div class="sub-item" style="background-image: url('/categories/{item.p}.jpg');">
        <div class="sub-item-text">{item.t}</div>
      </div>
    {/each}
  </div>
</div>


<div class="edit" on:click="{ () => load('Questions') }">
  <div class="edit-info">
    <div class="user-info">Questions</div>
  </div>
  <div class="edit-icon">
    <i class="icon-pencil3"></i>
  </div>
  <div class="edit-item">
    {#each myQuestions as item, index}
      <div class="question">Q: {Questions[index].question}</div>
      <div class="question-answer"><div class="me"></div> A: <strong>{ item.me != 0 ? Questions[index].answers[ item.me - 1 ] : 'No Answer' }</strong></div>
      <div class="question-slider">
        <MatchSlider me="{item.me}" them="{item.them}"></MatchSlider>
      </div>
    {/each}
  </div>
</div>


<div class="edit" on:click="{ () => load('Gender') }">
  <div class="edit-info">
    <div class="user-info">Gender</div>
  </div>
  <div class="edit-icon">
    <i class="icon-pencil3"></i>
  </div>
  <div class="edit-item">
    <div class="edit-extra">
      {genderLabel}
    </div>
  </div>
</div>


<div class="edit" on:click="{ () => load('Gender Looking For') }">
  <div class="edit-info">
    <div class="user-info">Looking For</div>
  </div>
  <div class="edit-icon">
    <i class="icon-pencil3"></i>
  </div>
  <div class="edit-item">
    <div class="edit-extra">
      {genderLookingFor}
    </div>
  </div>
</div>


<div class="edit" on:click="{ () => load('Age Preference') }">
  <div class="edit-info">
    <div class="user-info">Age Preference</div>
  </div>
  <div class="edit-icon">
    <i class="icon-pencil3"></i>
  </div>
  <div class="edit-item">
    <div class="edit-extra">
      {me.agePreference[0]} to {me.agePreference[1]}
    </div>
  </div>
</div>


<div class="edit" on:click="{ () => load('Location') }">
  <div class="edit-info">
    <div class="user-info">My Location</div>
  </div>
  <div class="edit-icon">
    <i class="icon-pencil3"></i>
  </div>
  <div class="edit-item">
    <div class="edit-extra">
      {me.lat}, {me.long}
    </div>
  </div>
</div>


<div class="edit" on:click="{ () => load('Social Links') }">
  <div class="edit-info">
    <div class="user-info">Social Links</div>
  </div>
  <div class="edit-icon">
    <i class="icon-pencil3"></i>
  </div>
  
  {#if me.socialLinks.length}
  
  <div class="edit-item">
    <div class="edit-extra">
      {#each me.socialLinks as item}
        <InfoBox icon="{item.icon}" theme="light" arrows="{false}">{item.link}</InfoBox>
      {/each}
    </div>
  </div>
    
  {/if}
</div>


<div class="edit">
  <div class="edit-info">
    <div class="user-info">My Next Upcoming Event</div>
  </div>
  <div class="edit-icon">
  </div>
  <div class="edit-item">
    
    {#if event.loaded}

    <div class="card" on:click="{ () => push('/events-info/'+event.eid) }">
      <img src="https://routes.hot0.workers.dev/ei/{localStorage.getItem('cookie')}/{localStorage.getItem('csrf')}/{event.eid}/{event.photoIds[0]}" alt="event" class="img">
      
      <div class="starts-in"><StartsIn currentTime="{currentTime}" start="{event.start}" end="{event.end}"></StartsIn></div>
      
      <div class="stars"><Stars stars="{event.stars}" largeStars="{false}"></Stars></div>
      
      <div class="info">
        <div class="event-name">{event.ename}</div>
        <div><EventTime start="{event.start}" end="{event.end}"></EventTime></div>
      </div>
    </div>
    
    {:else}
    
    <div class="user-info">No upcoming events.</div>
    
    {/if}
    
  </div>
  
  {#if event.loaded}
  
  <div class="edit-see-more">
    <button class="trans" on:click="{ () => push('/events-upcoming') }">See All Upcoming</button>
  </div>
  
  {/if}
  
</div>


<div class="edit">
  <div class="edit-info">
    <div class="user-info">Log Out</div>
  </div>
  
  <div class="edit-item">
    <div class="edit-extra center">
      <button class="trans" on:click="{logout}">Log Out Now</button>
    </div>
  </div>
    
</div>


{/if}


<div class="has-action-bar"></div>
<ActionBar bind:this="{actionbar}"></ActionBar>


<script>

import {push, pop, replace, location} from 'svelte-spa-router';

import Auth from "../interfaces/Auth.svelte";
let auth;

import Profile from "../interfaces/Profile.svelte";
let profile;

import Validate from "../helpers/Validate.js";
import tinterests from "../helpers/InterestCategories.js";
import Questions from "../helpers/Questions.js";
import Genders from "../helpers/Genders.js";

import Header from "../components/Header.svelte";
import ActionBar from "../components/ActionBar.svelte";
let actionbar;

import Stars from "../components/Stars.svelte";
import EventTime from "../components/EventTime.svelte";
import StartsIn from "../components/StartsIn.svelte";
import ValidInput from "../components/ValidInput.svelte";
import Dialog from "../components/DialogSlide.svelte";
import MatchSlider from "../components/MatchSlider.svelte";
import InfoBox from "../components/InfoBox.svelte";

import InviteCodes from "../components/EditMe/InviteCodes.svelte";
import Photos from "../components/EditMe/Photos.svelte";
import Name from "../components/EditMe/Name.svelte";
import AboutMe from "../components/EditMe/AboutMe.svelte";
import Email from "../components/EditMe/Email.svelte";
import EmailVerify from "../components/EditMe/EmailVerify.svelte";
import Phone from "../components/EditMe/Phone.svelte";
import PhoneVerify from "../components/EditMe/PhoneVerify.svelte";
import Password from "../components/EditMe/Password.svelte";
import Interests from "../components/EditMe/Interests.svelte";
import Gender from "../components/EditMe/Gender.svelte";
import QuestionsC from "../components/EditMe/Questions.svelte";
import GenderLookingFor from "../components/EditMe/GenderLookingFor.svelte";
import AgePreference from "../components/EditMe/AgePreference.svelte";
import Location from "../components/EditMe/Location.svelte";
import SocialLinks from "../components/EditMe/SocialLinks.svelte";

import UnitedStates from "../addresses/UnitedStates.js";

// create an interable version of the component.
// this is used for connecting various things in 
// the parent component with the child.

let standard = [ {text: 'Cancel', callback: 'close', disabled: false, }, {text: 'Save', callback: 'save', disabled: false, }, ] 

let done = [ {text: 'Done', callback: 'close', disabled: false, }, ];

let buttons = [];

// "component" is filled in by the HTML instantiation.
let EditMe = {
  "Invite Codes": {dialogHeight: 350, component: null, buttons: done },
  "Photos": {dialogHeight: "100%", component: null, buttons: standard, },
  "Name": {dialogHeight: 250, component: null, buttons: standard, },
  "About Me": {dialogHeight: 420, component: null, buttons: standard, },
  "Email": {dialogHeight: 270, component: null, buttons: standard, },
  "Email Verify": {dialogHeight: 500, component: null, buttons: done, },
  "Phone": {dialogHeight: 280, component: null, buttons: standard, },
  "Phone Verify": {dialogHeight: 500, component: null, buttons: done, },
  "Password": {dialogHeight: 380, component: null, buttons: standard, },
  "Interests": {dialogHeight: "100%", component: null, buttons: standard, },
  "Questions": {dialogHeight: "100%", component: null, buttons: standard, },
  "Gender": {dialogHeight: 400, component: null, buttons: standard, },
  "Gender Looking For": {dialogHeight: 430, component: null, buttons: standard, },
  "Age Preference": {dialogHeight: 280, component: null, buttons: standard, },
  "Location": {dialogHeight: 420, component: null, buttons: standard, },
  "Social Links": {dialogHeight: 500, component: null, buttons: standard, },
}

let interval = null;
let date = Math.round( Date.now() / 1000 );
let currentTime =  Math.round( Date.now() / 1000 );

let event = {loaded: false};

let editHeight = 200;
let edit = "";

let photosAdd = false;

// this is the "me" object that is passed around
// is filled in via profile.loadMe()
let me = {
  agePreference: [18,120],
  bio: "",
  birthday: "",
  distanceEvents: 10,
  distanceFriends: 25,
  email: "",
  gender: -1,
  interests: [],
  lat: 0,
  long: 0,
  lookingFor: [],
  name: "",
  phone: 0,
  photoIds: [],
  questions: [],
  socialLinks: [],
  uid: "",
  username: "",
}
// console.log("me:", me);

let allInterests = [];
let myInterests = [];
let myQuestions = [];
let genderLabel = "";
let genderLookingFor = "";

import { onMount } from "svelte";
onMount(async () => {
  interval = setInterval( () => { currentTime =  Math.round( Date.now() / 1000 ) }, 1000 * 60 * 1);
  
  profile.loadMe();
  loadNextUpcomingEvent();
});


$:{
  if (me.interests) parseInterests();
  if (me.questions) parseQuestions();
  if (me.gender) parseGender();
  if (me.lookingFor) parseGenderLookingFor();
}


async function loadNextUpcomingEvent() {
  let res = await auth.post("loadNextUpcomingEvent");
  event = JSON.parse(res);
  
  // if nothing was sent, then ename wont exist in event
  if ("ename" in event) {
    event.loaded = true;
  }
  
  event = event;
  // console.log("event:", event);
}


function parseInterests() {
  
  allInterests = tinterests.convert();
  // console.log("allInterests:", allInterests);
  
  myInterests = [];
  
  for (let i in allInterests) {
    if (allInterests[i].h == 1 && me.interests.includes(allInterests[i].i) == true) {
      myInterests.push( {p: allInterests[i].p/* photo */, t: allInterests[i].t/* text */} );
    }
  }
  
}


function parseQuestions() {
  myQuestions = [];
  for (let i in me.questions) {
    myQuestions.push({me: me.questions[i], them: 0})
  }
  
  me = me;
}


function parseGender() {
  for (let i in Genders.gender) {
    if (Genders.gender[i].i == me.gender) {
      genderLabel = Genders.gender[i].t;
    }
  }
}


function parseGenderLookingFor() {
  genderLookingFor = "";
  for (let i in Genders.lookingForOther) {
    if (me.lookingFor.includes(Genders.lookingForOther[i].i) == true) {
      genderLookingFor += genderLookingFor == '' ? Genders.lookingForOther[i].t : ", " + Genders.lookingForOther[i].t;
    }
  }
}


function cancel() {
  edit = "";
}


async function save() {
  console.log("edit", edit, "photosAdd:", photosAdd);

  // we don't want photos add = true to trugger a dialog close
  if (edit == "Photos" && photosAdd == true) {
    EditMe[edit].component.doneAdding();
    return;
  }
  
  // use the exported const from the component to save 
  await EditMe[edit].component.save();
  
  // reparsing
  if (edit == "Photos") actionbar.updateMe();
  if (edit == "Interests") parseInterests();
  if (edit == "Questions") parseQuestions();
  if (edit == "Gender" || edit == "Gender Looking For") parseGender();
  
  
  
  // reset the field and set up for the next field change
  edit = "";
}


function load(id) {
  edit = id;
  
  // pull suggested edit dialog height
  editHeight = EditMe[id].dialogHeight;
  buttons = EditMe[id].buttons;
}


async function logout() {
  let res = await auth.post("logout");
  localStorage.clear();
  document.location = "/";
}


</script>